import { FilterGroup } from 'types';
import { UserTypes } from 'types/api/users.type';

const createFilters = (userTypesValues: UserTypes[]): FilterGroup[] => [
  {
    id: 1,
    filters: [
      {
        name: 'email',
        label: 'Email',
      },
      {
        name: 'name',
        label: 'Name',
      },
      {
        name: 'surname',
        label: 'Last Name',
      },
    ],
  },
  {
    id: 2,
    filters: [
      {
        name: 'customerName',
        label: 'Company Name',
        flex: 1,
      },
      {
        name: 'userTypeId',
        label: 'User Type',
        type: 'select',
        options: userTypesValues.map((val) => ({ value: val.id, label: val.name })),
        flex: 1,
      },
    ],
  },
];

export { createFilters };
